export var UploadInputType;
(function (UploadInputType) {
    UploadInputType["image"] = "image/*";
    UploadInputType["audio"] = "audio/*";
    UploadInputType["text"] = "text/*";
    UploadInputType["json"] = "application/json";
    UploadInputType["video"] = "video/mp4,video/mpeg,video/x-m4v,video/*";
})(UploadInputType || (UploadInputType = {}));
